import {Component} from '@angular/core';

@Component({
    selector: 'course-licenses-support-article',
    template: `
        <ng-container i18n="@@support.articles.licenses">
            <p><strong>Instructors</strong> can use the course for free and therefore do not need a license. The condition for this is that at least as many students as instructors are registered in the organization.</p>
            <p>Each <strong>student</strong> needs a valid license to use the full course. Without a license, their access is limited to the trial version.</p>
            <p>There are two ways to purchase student licenses:</p>
            <ul>
                <li><strong>The organization purchases the licenses:</strong> The organization can purchase and activate the necessary licenses while enrolling students.</li>
                <li><strong>Students purchase their own license:</strong> Students are enrolled by the school without purchasing licenses. After logging in, the student can purchase a license.</li>
            </ul>
            <p>Both schools and companies enjoy an extra advantageous rate when purchasing licenses. When students of the organization purchase their own license, they enjoy the same discounted rate!</p>
        </ng-container>
    `
})
export class LicensesSupportArticleComponent {
}
